import {useTestRunQuery} from './useTestRunsQuery';

// READ-ONLY (FNP-969). Unlike useTestDefinition, this hook exposes no
// create/update/delete: the TestRun mutations are @aws_iam and belong to the
// executor canary. Fetch and refetch are the entire surface.
export const useTestRun = (testRunId?: string) => {
    const {
        data: record,
        isLoading: loading,
        isError,
        refetch: fetchRecord,
    } = useTestRunQuery(testRunId || '');

    return {
        record,
        loading,
        isError,
        fetchRecord,
    };
};
